<template>

  <div class="order-status-component">

    <div>
      <div class="container" v-if="this.loaded">
        <div class="row">
          <div class="col-12">
            <ul class="tabs">
              <li v-if="!this.isCurrent" :class="{ 'active' : active === 'order-status'}">
                <span @click="toggle('order-status')">Order Status</span>
              </li>
              <li :class="{ 'active' : active === 'vehicle-details'}">
                <span @click="toggle('vehicle-details')">Vehicle Details</span>
              </li>
              <li v-if="!this.isCurrent && currentProduct.financial_details_enabled" :class="{ 'active' : active === 'financial-details'}">
                <span @click="toggle('financial-details')">{{ financialTitle }}</span>
              </li>
              <li v-if="currentProduct.further_documents_enabled && order && orderConfirmed" :class="{ 'active' : active === 'funder-documents'}">
                <span @click="toggle('funder-documents')">{{ funderTitle }}</span>
              </li>
              <li v-if="this.isCurrent" :class="{ 'active' : active === 'vehicle-services'}">
                <span @click="toggle('vehicle-services')">Vehicle Services</span>
              </li>
              <hr/>
            </ul>
          </div>
        </div>
      </div>

      <template v-if="loaded">
        <template v-if="active === 'order-status' && !this.isCurrent">
          <order-status-content :order="order" :product="adminPortalPrimaryProduct"/>
          <order-status-faq :order="order" :product="adminPortalPrimaryProduct"/>
        </template>

        <template v-if="active === 'vehicle-details' || (active === 'order-status' && this.isCurrent)">
          <vehicle-details :order="order" :product="adminPortalPrimaryProduct"/>
        </template>

        <template v-if="currentProduct.financial_details_enabled && active === 'financial-details'">
          <financial-details :order="order" :driver-profile="driverProfile" :product="adminPortalPrimaryProduct"
            :isSalSacOrder="isSalSacOrder" :quoteCosts="quoteCosts"/>
        </template>

        <template v-if="currentProduct.further_documents_enabled && active === 'funder-documents'">
          <funder-documents :order="order" :driver-profile="driverProfile" :product="adminPortalPrimaryProduct"
            :isSalSacOrder="isSalSacOrder" :quoteCosts="quoteCosts" :adminPortalData="adminPortalData"/>
        </template>

        <template v-if="active === 'vehicle-services'">
          <vehicle-services :product="adminPortalPrimaryProduct"/>
        </template>

      </template>

    </div>
    <footer-text v-if="footerText" :footerText="footerText"/>


  </div>

</template>

<script>
import LoadingIcon from "../loading-icon";
import OrderStatusContent from "./order-status-content";
import FinancialDetails from "./financial-details";
import FunderDocuments from "./funder-documents";
import VehicleDetails from "./vehicle-details";
import OrderStatusFaq from "./order-status-faq";
import FooterText from "../footer/footer-text";
import {EventBus} from '@/event-bus';
import OrderStatus from "@/helpers/order-status";
import {useRoute} from "vue-router";
import { inferSchemeFromDriverGradeName } from "@/helpers/scheme";

export default {
  components: {
    FooterText,
    OrderStatusFaq, VehicleDetails, FunderDocuments, FinancialDetails, OrderStatusContent, LoadingIcon, EventBus
  },
  props: ['session', 'adminPortalPrimaryProduct', 'adminPortalData'], // TODO - this needs to be the product for the current order
  data() {
    return {
      active: 'order-status',
      isSalSacOrder: false,
      quoteCosts: null
    }
  },

  setup() {
    const route = useRoute()
    return { route }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.vehicles = [];
      EventBus.$emit('fetchData', [
        'driverprofile',
        'driverprofile/quotepolicies',
        'orders'
      ]);
      vm.type = vm.$route.meta.type;
    })
  },
  computed: {
    loaded() {
      return this.order;
    },
    scheme() {
      if (this.order) {
        return this.inferSchemeFromDriverGradeName(this.order.quote.details.driverGradeName);
      }
    },
    order() {
      if (this.session.orders) {
        let viewingOrder;
        //TODO this should be refined but for now it's the quickest route as the orders are already loaded
        this.session.orders.results.forEach((order) => {
          if (order.orderID == this.$route.params.orderId) {
            viewingOrder = order;
            this.isSalSacOrder = order.contract.productDescription.includes('Salary Sacrifice');  // urgh... just... urgh

            if (this.isSalSacOrder) {
              this.fetchQuoteCosts(order.quoteID);
            }
          }
        });

        return viewingOrder;
      }
      return null
    },
    currentProduct() {
      if (this.scheme) {
        return this.adminPortalData?.content?.products?.[this.scheme]?.[0];
      }
    },
    driverProfile() {
      return this.session.driverProfile;
    },
    isCurrent() {
      return (this.loaded && this.order.orderStatusDescription === 'Implemented');
    },
    footerText() {
      return this.adminPortalPrimaryProduct?.fca_requirement_and_content_fca_description_required
      && this.adminPortalPrimaryProduct?.fca_requirement_and_content_fca_description
      && this.adminPortalPrimaryProduct?.fca_description_required_on_order_process_management
        ? this.adminPortalPrimaryProduct.fca_requirement_and_content_fca_description
        : false;
    },
    financialTitle() {
      return this.isSalSacOrder ? 'Salary Sacrifice Details' : 'Financial Details';
    },
    funderTitle() {
      return this.isSalSacOrder ? 'Salary Sacrifice Agreement' : 'Funder Documents';
    },
    orderConfirmed() {
      return OrderStatus.hasProgressedToStage('Order Confirmed', this.order.orderStatusDescription);
    },
  },
  methods: {
    inferSchemeFromDriverGradeName,

    toggle(id) {
      this.active = id;
    },
    /* This isn't currently used, see the `order` computed property */
    async fetchOrder() {
      let order, response;

      try {
        // Grab the order
        response = await this.$http.post('/api/quotation', {
          method: 'GET',
          endpoint: 'orders/' + this.$route.params.orderId,
        });

        order = response.data.data;

        response = await this.$http.post('/api/quotation', {
          method: 'GET',
          endpoint: 'quotes/' + order.quoteID,
        });

        order.quote = response.data.data;

        // Grab the associated tax calculations
        response = await this.$http.post('/api/quotation', {
          method: 'GET',
          endpoint: 'quotes/' + order.quoteID + '/TaxCalculations/Latest',
        });

        order.quote.taxCalculations = response.data.data;

        // Grab the associated vehicle derivative
        response = await this.$http.post('/api/quotation', {
          method: 'GET',
          endpoint: 'derivatives/' + order.quote.definition.derivativeID,
        });

        order.quote.derivative = response.data.data;

        this.order = order;

      } catch (err) {
        let response = err.response.data;

        this.$notify({
          group: 'notify',
          type: 'error',
          title: 'Error',
          text: response.message
        });
      }

    },

    async fetchQuoteCosts(quoteId) {
      EventBus.$emit('loading', true);

      try {
        // Moved to it's own endpoint to save the faffing
        const response = await this.$http.get('/api/get-salary-sacrifice-costs/' + quoteId);

        if (response.data.status !== 200) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: 'Error',
            text: response.data.error.message
          });
        } else {
          this.quoteCosts = response.data.data;
        }


      } catch (err) {
        let response = err.response.data;

        this.$notify({
          group: 'notify',
          type: 'error',
          title: 'Error',
          text: response.message
        });
      }

      EventBus.$emit('loading', false);
    }
  }
}
</script>

<style scoped lang="scss">

.order-status-component {
  background-color: white;
  overflow-x: hidden;
}

</style>
